<template>
	<QrcodeNavShell
		variant="solid"
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		@select="$emit('select')"
	/>
</template>

<script>
	import QrcodeNavShell from '../shared/QrcodeNavShell.vue';
	import { qrcodeNavMixin } from '../shared/mixin.js';

	export default {
		name: 'GBlockQrcodeNavSolid',
		components: { QrcodeNavShell },
		mixins: [qrcodeNavMixin],
	};
</script>
